/*
 * File: /src/services/knowledgeCategoryService.js
 * Author: AdBase, Inc.
 * Copyright (c) 2026 AdBase, Inc.
 *
 * Knowledge categories are a flat list per company. The list call takes no
 * paging, the API hands back every category ordered by name.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_KNOWLEDGE_CATEGORIES_PATH } from '../constants';

export default {
  fetchKnowledgeCategories() {
    return authedAxios.get(S2_KNOWLEDGE_CATEGORIES_PATH);
  },
  fetchKnowledgeCategory(id) {
    return authedAxios.get(S2_KNOWLEDGE_CATEGORIES_PATH + id);
  },
  createKnowledgeCategory(payload) {
    return authedAxios.post(S2_KNOWLEDGE_CATEGORIES_PATH, payload);
  },
  // The API takes the whole record on update, not a partial
  updateKnowledgeCategory(id, payload) {
    return authedAxios.put(S2_KNOWLEDGE_CATEGORIES_PATH + id, payload);
  },
  deleteKnowledgeCategory(id) {
    return authedAxios.delete(S2_KNOWLEDGE_CATEGORIES_PATH + id);
  },
};
